import { strClear } from '@core/utils/utils'
import moment from 'moment'

export const validatorPositive = value => value >= 0

export const validatorPassword = password => {
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  return regExp.test(password)
}

export const validatorCreditCard = creditnum => {
  const cRegExp = /^(?:3[47][0-9]{13})$/
  return cRegExp.test(creditnum)
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const validatorCPF = cpf => {
  cpf = strClear(cpf)
  if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false
  let result = true;
  [9, 10].forEach(j => {
    let soma = 0
    let r
    cpf
      .split(/(?=)/)
      .splice(0, j)
      .forEach((e, i) => {
        soma += parseInt(e) * (j + 2 - (i + 1))
      })
    r = soma % 11
    r = r < 2 ? 0 : 11 - r
    if (r != cpf.substring(j, j + 1)) result = false
  })
  return result
}

export const validatorCNPJ = doc => {
  const regexCaracteresMascara = /[.\-/]/g
  const regexCaracteresNaoPermitidos = /[^A-Z\d.\-/]/i
  const regexCNPJ = /^[A-Z\d]{12}\d{2}$/
  const cnpjZerado = '00000000000000'
  const tamanhoCNPJSemDV = 12
  const valorBase = '0'.charCodeAt(0)
  const pesosDV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

  if (regexCaracteresNaoPermitidos.test(doc)) return false

  const cnpjSemMascara = doc.replace(regexCaracteresMascara, '').toUpperCase()

  if (cnpjSemMascara.length !== 14) return false
  if (!regexCNPJ.test(cnpjSemMascara)) return false
  if (cnpjSemMascara === cnpjZerado) return false

  let somatorioDV1 = 0
  let somatorioDV2 = 0

  for (let i = 0; i < tamanhoCNPJSemDV; i++) {
    const asciiDigito = cnpjSemMascara.charCodeAt(i) - valorBase
    somatorioDV1 += asciiDigito * pesosDV[i + 1]
    somatorioDV2 += asciiDigito * pesosDV[i]
  }

  const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11)
  somatorioDV2 += dv1 * pesosDV[tamanhoCNPJSemDV]
  const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11)

  const dvCalculado = `${dv1}${dv2}`
  const dvInformado = cnpjSemMascara.substring(tamanhoCNPJSemDV)

  return dvInformado === dvCalculado
}

export const validatorCpfCnpj = cpfCnpj => {
  const doc = cpfCnpj.replace(/[.\-/\s]/g, '')

  if (doc.length <= 11) {
    return validatorCPF(doc)
  }

  return validatorCNPJ(doc)
}

export const validatorDateOfBirth = nascimento => {
  if (nascimento.length < 10) {
    return false
  }

  const today = moment().format('YYYY-MM-DD')
  const dateInValidation = moment(nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD')

  if (moment(dateInValidation, 'YYYY-MM-DD').isAfter(today)) {
    return false
  }

  const diff = moment(today, 'YYYY-MM-DD').diff(moment(dateInValidation, 'YYYY-MM-DD'))

  const years = moment.duration(diff).asYears()

  return !(years <= 0 || years > 150)
}

export const validateEquals = (value, _a) => {
  return String(value) === String(_a[0])
}
